import { _ as _createClass, a as _classCallCheck } from './_rollupPluginBabelHelpers-e31ab38d.js';

var ModalButton = /*#__PURE__*/_createClass(function ModalButton(title, cb) {
  _classCallCheck(this, ModalButton);
  this.title = title;
  this.cb = cb;
});

export { ModalButton as M };
